module.exports = __webpack_public_path__ + "static/img/img-7.c4ef1d59.png";